module.exports = __webpack_public_path__ + "static/img/our-people-company-values-hero-lowres.58e695d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-values-hero-lowres.jpg
// module id = AUPG
// module chunks = 0